import { MultiSelectActionsContainer } from 'src/components/common/MultiSelect/MultiSelectActionsContainer';
import { usePosLiteAccount } from 'src/hooks/usePosLiteAccount';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { Feature } from 'src/WebApiController';

import { BoostActions } from './Actions/BoostActions';
import { BroadcastActions } from './Actions/BroadcastActions';
import { CatchUpAction } from './Actions/CatchUpAction';
import { GroupActions } from './Actions/GroupActions';
import { PricingActions } from './Actions/PricingActions';
import { SettingsActions } from './Actions/SettingsActions';
import { TagsActions } from './Actions/TagsActions';

export const InventoryGlobalBulkActions = () => {
  const hasGroupListingsAcrossEventsFeature = useUserHasFeature(
    Feature.GroupListingsAcrossEvents
  );
  const isPosLite = usePosLiteAccount();
  return (
    <MultiSelectActionsContainer>
      {!isPosLite && hasGroupListingsAcrossEventsFeature && <GroupActions />}
      {!isPosLite && <PricingActions />}
      {!isPosLite && <TagsActions />}
      {!isPosLite && <BroadcastActions />}
      {!isPosLite && <SettingsActions />}
      {!isPosLite && <CatchUpAction />}
      <BoostActions />
    </MultiSelectActionsContainer>
  );
};
